import { CheckConfModal } from '@features/appointment/check-conf'
import { ConferenceSettingsModal } from '@features/appointment/conference-settings'
import { FullscreenVideoModal } from '@features/appointment/fullscreen-video'
import { RemoveAppointmentsNoteModal } from '@features/appointment/remove-appointments-note'
import { RemoveHomeworkModal } from '@features/appointment/remove-homework'
import React from 'react'

export const AppointmentModals = () => {
	return (
		<>
			<CheckConfModal/>
			<FullscreenVideoModal/>
			<RemoveAppointmentsNoteModal/>
			<RemoveHomeworkModal/>
			<ConferenceSettingsModal />
		</>
	)
}
